import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/event/modi/ranking-top-img.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-732da0ca")

_pushScopeId("data-v-732da0ca")
const _hoisted_1 = {
  key: 0,
  class: "ranking"
}
const _hoisted_2 = { class: "monthly-true" }
const _hoisted_3 = { class: "period-day" }
const _hoisted_4 = { class: "period-color" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "space-bg-gradation" }, null, -1)
const _hoisted_6 = { class: "ranking-user-lists" }
const _hoisted_7 = { class: "ranking2" }
const _hoisted_8 = { class: "ranking1" }
const _hoisted_9 = { class: "ranking3" }
const _hoisted_10 = {
  key: 1,
  class: "ranking"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("img", {
  class: "ranking-title",
  src: _imports_0
}, null, -1)
const _hoisted_12 = { class: "monthly-true" }
const _hoisted_13 = { class: "period-day" }
const _hoisted_14 = { class: "period-color" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "space-bg-gradation" }, null, -1)
const _hoisted_16 = { class: "ranking-user-lists" }
const _hoisted_17 = { class: "ranking2" }
const _hoisted_18 = { class: "ranking1" }
const _hoisted_19 = { class: "ranking3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_RankingSecond = _resolveComponent("RankingSecond")
  const _component_RankingFirst = _resolveComponent("RankingFirst")
  const _component_RankingThird = _resolveComponent("RankingThird")
  const _component_LPRankingUser = _resolveComponent("LPRankingUser")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (!_ctx.state.isLoading && _ctx.state.enableEvent)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("img", {
            class: "ranking-title",
            src: _ctx.loadImg()
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("p", _hoisted_4, "2021年12月1日 〜 " + _toDisplayString(_ctx.endDate), 1)
            ]),
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_RankingSecond, {
                  name: _ctx.state.monthly[1].influencer.displayName,
                  score: _ctx.state.monthly[1].points,
                  path: _ctx.state.monthly[1].influencer.mainImage
                }, null, 8, ["name", "score", "path"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode(_component_RankingFirst, {
                  name: _ctx.state.monthly[0].influencer.displayName,
                  score: _ctx.state.monthly[0].points,
                  path: _ctx.state.monthly[0].influencer.mainImage
                }, null, 8, ["name", "score", "path"])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_RankingThird, {
                  name: _ctx.state.monthly[2].influencer.displayName,
                  score: _ctx.state.monthly[2].points,
                  path: _ctx.state.monthly[2].influencer.mainImage
                }, null, 8, ["name", "score", "path"])
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.monthly.slice(3), (monthly, index) => {
              return (_openBlock(), _createBlock("p", null, [
                _createVNode(_component_LPRankingUser, {
                  name: monthly.influencer.displayName,
                  score: monthly.points,
                  path: monthly.influencer.mainImage,
                  index: index
                }, null, 8, ["name", "score", "path", "index"])
              ]))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.state.isLoading && !_ctx.state.enableEvent)
      ? (_openBlock(), _createBlock("div", _hoisted_10, [
          _hoisted_11,
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("p", _hoisted_14, "2021年12月1日 〜 " + _toDisplayString(_ctx.endDate), 1)
            ]),
            _hoisted_15,
            _createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_RankingSecond, {
                  name: "集計中",
                  score: "0",
                  path: ""
                })
              ]),
              _createVNode("div", _hoisted_18, [
                _createVNode(_component_RankingFirst, {
                  name: "集計中",
                  score: "0",
                  path: ""
                })
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode(_component_RankingThird, {
                  name: "集計中",
                  score: "0",
                  path: ""
                })
              ])
            ]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.monthly.slice(3), (monthly, index) => {
              return (_openBlock(), _createBlock("p", null, [
                _createVNode(_component_LPRankingUser, {
                  name: "集計中",
                  score: "0",
                  path: "",
                  index: index
                }, null, 8, ["index"])
              ]))
            }), 256))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})